export { default } from './newsletter';
